import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { withAuthenticationRequired } from '@auth0/auth0-react'

import breakpoints from 'common/breakpoints'
import Intercom from 'common/components/intercom/Intercom'
import Loader from 'common/components/loaders/Loader'
import TopNavBar from 'common/components/navigation/topNavBar'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import useDataIngestionStatusNotification from 'features/admin/dataSources/useDataIngestionStatusNotification'
import { cancelCreateCampaign } from 'features/campaigns/store/campaignSlice'
import useNewLanguageWebsocketSubscription from 'features/unifiedFlow/contentPage/hooks/useNewLanguageWebsocketSubscription'

import 'common/services/HighchartsPlugin'

import Drawer from './IntegrationDrawer'

const App: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { accountId } = useAppSelector((state) => state.authStates)

  useEffect(() => {
    // handle browser back button click
    return history.listen(() => {
      if (history.action === 'POP') {
        dispatch(cancelCreateCampaign())
      }
    })
  }, [dispatch, history])

  useDataIngestionStatusNotification()
  useNewLanguageWebsocketSubscription()
  return (
    <div
      key={accountId}
      style={{ minWidth: breakpoints.xs }}
      className="flex overflow-x-auto "
    >
      <div className="flex flex-col h-screen w-full bg-gold-40 overflow-y-hidden">
        <TopNavBar />
        {children}
      </div>
      <Drawer />
      <Intercom />
    </div>
  )
}

// failsafe mechanism to make sure private routes are protected
export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader isFullPage />,
})
